import { render, staticRenderFns } from "./FontSelector.vue?vue&type=template&id=78261cb3&scoped=true"
import script from "./FontSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./FontSelector.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78261cb3",
  null
  
)

export default component.exports